/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SubmitDelegatedOAuthRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'
import {SubmitDelegatedOAuthResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'


export const submitDelegatedOauth = (request: SubmitDelegatedOAuthRequest, options?: CashRequestOptions) => post<SubmitDelegatedOAuthRequest, SubmitDelegatedOAuthResponse>("/2.0/cash/submit-delegated-oauth", request, {...options, rejectOnError: true })